export default __webpack_public_path__ + "static/media/08.7ca7c8b6.jpg";